const a2 = require('./applications/new_application.json');
const a3 = require('./applications/update_application.json');

const d1 = require('./datasource/add_datasource.json');
const d2 = require('./datasource/update_datasource.json');
const d3 = require('./datasource/update_gigatest_datasource.json');
const d5 = require('./datasource/upgrade_agent.json');

const p1 = require('./profile/add_profile.json');
const p1update = require('./profile/update_profile.json');
const r1 = require('./radius-servers/add_radius_server.json');
const r2 = require('./radius-servers/update_radius_server.json');
const s1 = require('./sites/add_sites.json');
const s2 = require('./sites/update_sites.json');
const s3 = require('./sites/add_agent.json');

const t1 = require('./threshold/add_site_threshold.json');
const t2 = require('./threshold/add_app_threshold.json');
const t3 = require('./threshold/add_appsite_threshold.json');
const t4 = require('./threshold/update_threshold.json');
const t5 = require('./threshold/add_hist_appsite_threshold.json');
const t6 = require('./threshold/add_hist_site_threshold.json');
const t7 = require('./threshold/add_hist_app_threshold.json');
const t8 = require('./threshold/add_hist_appsite_threshold.json');
const t9 = require('./threshold/add_hist_siteserver_threshold.json');
const t10 = require('./threshold/add_hist_appserver_threshold.json');
const t11 = require('./threshold/add_hist_appsiteserver_threshold.json');
const t12 = require('./threshold/update_historical_threshold.json');
const t13 = require('./threshold/add_hist_server_threshold.json');

const u1 = require('./users/add_new_user.json');
const u2 = require('./users/add_user_to_groups.json');
const u3 = require('./users/add_users_to_roles.json');
const u4 = require('./users/inv_user.json');
const u5 = require('./users/new_user_group.json');
const u6 = require('./users/remove_user_from_group.json');
const u7 = require('./users/remove_users_from_roles.json');
const u8 = require('./users/update_user_password_admin.json');
const u9 = require('./users/update_user_password.json');
const u10 = require('./users/update_user.json');
const u11 = require('./users/user_app_selection.json');
const u12 = require('./users/user_site_selection.json');
const u13 = require('./users/add_new_user_fusion.json');
const u14 = require('./users/add_new_user_fusion_sso.json');
const u15 = require('./users/update_fusion_sso_user.json');
const u16 = require('./users/fusion_sso_add_user_to_group.json');
const u17 = require('./users/fusion_sso_remove_user_from_group.json');
const ipam = require('./ipam/ipam.config.json');
const syslog_add = require('./syslog/add_syslog.config.json');
const syslog_update = require('./syslog/update_syslog.config.json');
const activeTest = require('./activetest/active_test.json');
const mlrca = require('./machine-learning/ml_select_application_for_reset.json');
const mlrcs = require('./machine-learning/ml_select_site_for_reset.json');
const mlrck = require('./machine-learning/ml_select_kpi_for_reset.json');
const cpu = require('./profile/confirm_profile_update.json');

const l1 = require('./ldap-servers/add_ldap_server.json');
const l2 = require('./ldap-servers/update_ldap.server.json');

const widgets = [
  a2,
  a3,
  d1,
  d2,
  d3,
  d5,
  p1,
  p1update,
  r1,
  r2,
  s1,
  s2,
  s3,
  t1,
  t2,
  t3,
  t4,
  t5,
  t6,
  t7,
  t8,
  t9,
  t10,
  t11,
  t12,
  t13,
  u1,
  u2,
  u3,
  u4,
  u5,
  u6,
  u7,
  u8,
  u9,
  u10,
  u11,
  u12,
  u13,
  u14,
  u15,
  u16,
  u17,
  ipam,
  syslog_add,
  syslog_update,
  activeTest,
  mlrca,
  mlrcs,
  mlrck,
  cpu,
  l1,
  l2
];

//eslint-disable-next-line @typescript-eslint/no-explicit-any
export function loadWizards(): any {
  const result = {};
  for (const widget of widgets) {
    result[widget.id] = widget;
  }
  return result;
}
